const SET_NOTIFICATION = 'efes/notification/SET_NOTIFICATION';
const CLEAN_NOTIFICATION = 'efes/notification/CLEAN_NOTIFICATION';

const initialState = {
  message: '',
  notificationType: 'error',
};
const DISMISS_TIMEOUT = 5000;
let autoDissmissNotification;
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_NOTIFICATION:
      return {
        ...state,
        message: action.message,
        notificationType: action.notificationType,
      };
    case CLEAN_NOTIFICATION:
      return {
        ...state,
        message: '',
        notificationType: null,
      };

    default:
      return state;
  }
}
export function hideNotification() {
  return {
    type: CLEAN_NOTIFICATION,
  };
}

export function showError(errorMessage) {
  return {
    type: SET_NOTIFICATION,
    message: errorMessage,
    notificationType: 'error',
  };
}

export function showSuccess(successMessage) {
  return {
    type: SET_NOTIFICATION,
    message: successMessage,
    notificationType: 'success',
  };
}

function autoDismissNotification(action) {
  return (dispatch) => {
    dispatch(action);
    if (autoDissmissNotification) {
      clearTimeout(autoDissmissNotification);
    }
    autoDissmissNotification = setTimeout(() => {
      dispatch(hideNotification());
    }, DISMISS_TIMEOUT);
  };
}

export function showAutoDismissableError(errorMessage) {
  return autoDismissNotification(showError(errorMessage));
}

export function showAutoDismissableSuccess(successMessage) {
  return autoDismissNotification(showSuccess(successMessage));
}
